// extracted by mini-css-extract-plugin
export default {"card":"YZ-z","carouselContainer":"ZZ-z","carouselContent":"_Z-z"};